import React, { Component } from 'react';
import { Image } from 'react-bootstrap'
import Api from './../../Global/Modules/Api';
import uploadedImage from './../../../images/cr-logo-new.png'

class Announcement extends Component {
  constructor() {
    super();
    this.state = {
      Title: '',
      Description: '',
      Message: '',
      DateCreated: '',
      id: 0
    }
  }
  rawMarkup() {
    var rawMarkup = this.state.Message
    return { __html: rawMarkup };
  }

  componentDidUpdate() {
    if (this.state.id === this.props.niew) {

    } else {
      this.setState({ id: this.props.niew });
      const FETCH_URL = 'api/news/' + this.props.niew;
      Api.GetApi(FETCH_URL).then(data => {
        this.setState({ Title: data.title, image: data.image, Description: data.description, Message: data.message, DateCreated: Api.formatDate(data.dateCreated) });
      });
    }

  }
  componentDidMount() {
    this.setState({ id: this.props.niew });
    const FETCH_URL = 'api/news/' + this.props.niew;
    Api.GetApi(FETCH_URL).then(data => {
      this.setState({ Title: data.title, image: data.image, Description: data.description, Message: data.message, DateCreated: Api.formatDate(data.dateCreated) });
    });
  }
  render() {
    return (
      <div className="route">
        <div>
          <h1 className="pageTitle">
            {this.state.Title}

          </h1>
        </div>
        <div>
          <Image src={this.state.image == 'news/' ? uploadedImage : Api.Url + this.state.image} thumbnail style={{ float: 'right' }} />
          <p className="display-linebreak" >
            {this.state.Description}
          </p>
          <br />
          <p>
            <p className="display-linebreak" dangerouslySetInnerHTML={this.rawMarkup()} />
          </p>
        </div>
      </div>
    )
  }
}

export default Announcement;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/AnnouncementDetail.js